// auth.listener.ts

import firebase from 'firebase';
import { AppDispatch } from '../../store';
import { COLLECTIONS } from '../../constants/data';
import { serializeFirebaseUserSnap } from './auth.service';
import { firebaseUserUpdated, resetUser } from './auth.slice';

let unsubscribeUser: firebase.Unsubscribe | null = null;
let activeUid: string | null = null;

export const syncUserListener = (
  uid: string | null,
  dispatch: AppDispatch
) => {
  if (uid === activeUid) return;

  if (unsubscribeUser) {
    unsubscribeUser();
    unsubscribeUser = null;
  }

  activeUid = uid;

  if (!uid) {
    dispatch(resetUser());
    return;
  }

  unsubscribeUser = firebase
    .firestore()
    .collection(COLLECTIONS.users)
    .doc(uid)
    .onSnapshot(
      (snapshot) => {
        if (!snapshot.exists) return;
        dispatch(firebaseUserUpdated(serializeFirebaseUserSnap(snapshot)));
      },
      (error) => {
        console.error(error);
        activeUid = null;
        unsubscribeUser = null;
      }
    );
};